/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { WinningCriteria } from './WinningCriteria';
import {
    WinningCriteriaFromJSON,
    WinningCriteriaFromJSONTyped,
    WinningCriteriaToJSON,
    WinningCriteriaToJSONTyped,
} from './WinningCriteria';

/**
 * Collection contains the user's reward stats/progress.
 * @export
 * @interface CreateSponsoredRewardRequest
 */
export interface CreateSponsoredRewardRequest {
    /**
     * 
     * @type {WinningCriteria}
     * @memberof CreateSponsoredRewardRequest
     */
    winningCriteria: WinningCriteria;
    /**
     * Legacy source — exactly one of rewardConfigId | rewardGrant.
     * @type {string}
     * @memberof CreateSponsoredRewardRequest
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {RewardGrant}
     * @memberof CreateSponsoredRewardRequest
     */
    rewardGrant?: RewardGrant;
    /**
     * Starting rank for this reward (1-indexed). Only used for TOP_OVERALL_XP_GAINER.
     * @type {number}
     * @memberof CreateSponsoredRewardRequest
     */
    rankStart?: number;
    /**
     * Ending rank for this reward (inclusive). Only used for TOP_OVERALL_XP_GAINER.
     * @type {number}
     * @memberof CreateSponsoredRewardRequest
     */
    rankEnd?: number;
}



/**
 * Check if a given object implements the CreateSponsoredRewardRequest interface.
 */
export function instanceOfCreateSponsoredRewardRequest(value: object): value is CreateSponsoredRewardRequest {
    if (!('winningCriteria' in value) || value['winningCriteria'] === undefined) return false;
    return true;
}

export function CreateSponsoredRewardRequestFromJSON(json: any): CreateSponsoredRewardRequest {
    return CreateSponsoredRewardRequestFromJSONTyped(json, false);
}

export function CreateSponsoredRewardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSponsoredRewardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'winningCriteria': WinningCriteriaFromJSON(json['winningCriteria']),
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'rewardGrant': json['rewardGrant'] == null ? undefined : RewardGrantFromJSON(json['rewardGrant']),
        'rankStart': json['rankStart'] == null ? undefined : json['rankStart'],
        'rankEnd': json['rankEnd'] == null ? undefined : json['rankEnd'],
    };
}

export function CreateSponsoredRewardRequestToJSON(json: any): CreateSponsoredRewardRequest {
    return CreateSponsoredRewardRequestToJSONTyped(json, false);
}

export function CreateSponsoredRewardRequestToJSONTyped(value?: CreateSponsoredRewardRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'winningCriteria': WinningCriteriaToJSON(value['winningCriteria']),
        'rewardConfigId': value['rewardConfigId'],
        'rewardGrant': RewardGrantToJSON(value['rewardGrant']),
        'rankStart': value['rankStart'],
        'rankEnd': value['rankEnd'],
    };
}

